import { render } from "./TarjetasTratamientosActivos.vue?vue&type=template&id=3ab20fa6&ts=true"
import script from "./TarjetasTratamientosActivos.vue?vue&type=script&lang=ts"
export * from "./TarjetasTratamientosActivos.vue?vue&type=script&lang=ts"

import "./TarjetasTratamientosActivos.vue?vue&type=style&index=0&id=3ab20fa6&lang=css"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__